<script>
  import { fade } from "svelte/transition";
  import { EXPERIENCE_TYPES, FADE_DURATION } from "../consts";
  import { logButtonClick } from "@services/analytics";
  import { _ } from "@services/i18n";
  import { experienceType, textMode } from "@stores/global";
  import CloseButton from "@components/CloseButton.svelte";

  /**
   * Toggle experience type
   * text input vs voice input
   */
  function toggleExperienceType() {
    if ($textMode) {
      experienceType.set(EXPERIENCE_TYPES.VOICE);
    } else {
      experienceType.set(EXPERIENCE_TYPES.TEXT);
    }

    logButtonClick("experience_type_toggle");
  }
</script>

<style>
  .text {
    background-color: transparent;
    border: 0;
    bottom: 2.2rem;
    color: var(--primary-color);
    cursor: pointer;
    font-size: 1.6rem;
    font-weight: 700;
    left: 2rem;
    letter-spacing: -1.5px;
    line-height: 1;
    margin: 0;
    padding: 0;
    position: absolute;
    text-decoration: none;
    text-shadow: -1px -1px 2px var(--thin-shadow),
      1px -1px 2px var(--thin-shadow), -1px 1px 2px var(--thin-shadow),
      1px 1px 2px var(--thin-shadow);
    text-transform: uppercase;
  }
</style>

{#if $textMode}
  <CloseButton
    onClick={toggleExperienceType}
    style="bottom: 2.2em; left: 1rem; top: auto" />
{:else}
  <button
    class="text"
    on:click|preventDefault={toggleExperienceType}
    transition:fade={{ duration: FADE_DURATION }}
    type="button">
    {$_("components.experience_type_toggle.button.text", { default: "Text" })}
  </button>
{/if}
